import React, { useRef, useState } from "react";
import { PrimaryButton, DefaultButton, Checkbox, TextField, ITextField, BaseButton, Button } from "@fluentui/react";
import { IActionConfiguration } from "./SLActionsManagerTypes";
import { css } from "@emotion/css";

const submissionStyles = css`
  position: relative;
  & .action-manager--footer-action {
    max-width: 360px;
  }
  & .action-manager--footer-buttons {
    display: flex;
    margin: 16px 0 0 0;
    justify-content: flex-end;

    & button:first-of-type {
      margin: 0 16px 0 0;
    }
  }
`;

export interface ITextFieldProps extends IActionConfiguration {
  onSubmit: (type: "submit" | "cancel", text: string) => void;
}

export interface ICheckboxProps extends IActionConfiguration {
  onSubmit: (type: "submit" | "cancel") => void;
}

export const TextFieldSubmission = (props: ITextFieldProps): JSX.Element => {
  const textRef = useRef<ITextField>(null);
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = (
    event: React.MouseEvent<
      HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement,
      MouseEvent
    >
  ) => {
    event.stopPropagation();
    if (textRef.current) {
      if (!textRef.current.value) {
        setErrorMessage("This field is required. Please enter a value.");
      } else {
        if (errorMessage) {
          setErrorMessage("");
        }
        props.onSubmit("submit", textRef.current.value);
      }
    }
  };

  const onCancel = (
    event: React.MouseEvent<
      HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement,
      MouseEvent
    >
  ) => {
    event.stopPropagation();
    setErrorMessage("");
    if (textRef.current) {
      props.onSubmit("cancel", "");
    }
  };

  return (
    <div className={submissionStyles}>
      <div className="action-manager--footer-action">
        <TextField name="dialogText" label={props.subText} componentRef={textRef} errorMessage={errorMessage} />
      </div>
      <div className="action-manager--footer-buttons">
        <PrimaryButton onClick={onSubmit} text={props.confirmText} />
        <DefaultButton onClick={onCancel} text="Cancel" />
      </div>
    </div>
  );
};

export const CheckBoxSubmission = (props: ICheckboxProps): JSX.Element => {
  const [disabled, setDisabled] = useState(true);
  const onChangeCheckBox = () => {
    setDisabled(false);
  };

  const onSubmit = (
    event: React.MouseEvent<
      HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement,
      MouseEvent
    >
  ) => {
    event.stopPropagation();
    props.onSubmit("submit");
  };

  const onCancel = (
    event: React.MouseEvent<
      HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement,
      MouseEvent
    >
  ) => {
    event.stopPropagation();
    props.onSubmit("cancel");
  };

  return (
    <div className={submissionStyles}>
      <div className="action-manager--footer-action">
        <Checkbox label={props.subText} onChange={onChangeCheckBox} />
      </div>
      <div className="action-manager--footer-buttons">
        <PrimaryButton onClick={onSubmit} disabled={disabled} text={props.confirmText} />
        <DefaultButton onClick={onCancel} text="Cancel" />
      </div>
    </div>
  );
};
